export const addressBookColumns: Record<string, string> = {
    serialNumber: 'S.No',
    addressCode: 'Address Code',
    nationalAddressCode: 'National Address Code',
    companyName: 'Company Name',
    name: 'Name',
    pincode: 'Pincode',
    phone: 'Mobile No.',
    alternatePhone: 'Alternate Phone',
    alternatePhone2: 'Alternate Phone 2',
    notes: 'Notes',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    cityName: 'City',
    stateName: 'State',
    countryName: 'Country',
    latitude: 'Latitude',
    longitude: 'Longitude',
    email: 'Email',
    timeSlotList: 'Time Slot',
    serviceTime: 'Service Time',
    actions: 'Actions',
};

export type FieldMeta = {
    label: string;
    dataIndex: string;
    width?: number;
};

// Mapping from backend snake_case keys to frontend camelCase dataIndex
export const addressFieldMetadata: Record<string, FieldMeta> = {
    address_id: { label: 'addressCode', dataIndex: 'addressCode', width: 130 },
    name: { label: 'name', dataIndex: 'name', width: 150 },
    company_name: { label: 'companyName', dataIndex: 'companyName', width: 150 },
    address_line_1: { label: 'addressLine1', dataIndex: 'addressLine1', width: 200 },
    address_line_2: { label: 'addressLine2', dataIndex: 'addressLine2', width: 200 },
    address_line_3: { label: 'addressLine3', dataIndex: 'addressLine3', width: 200 },
    address_line_4: { label: 'addressLine4', dataIndex: 'addressLine4', width: 200 },
    address_line_5: { label: 'addressLine5', dataIndex: 'addressLine5', width: 200 },
    pincode: { label: 'pincode', dataIndex: 'pincode', width: 100 },
    city: { label: 'cityName', dataIndex: 'cityName', width: 120 },
    state: { label: 'stateName', dataIndex: 'stateName', width: 120 },
    country: { label: 'countryName', dataIndex: 'countryName', width: 120 },
    phone: { label: 'phone', dataIndex: 'phone', width: 130 },
    alternate_phone: { label: 'alternatePhone', dataIndex: 'alternatePhone', width: 130 },
    alternate_phone_2: { label: 'alternatePhone2', dataIndex: 'alternatePhone2', width: 130 },
    notes: { label: 'notes', dataIndex: 'notes', width: 200 },
    email: { label: 'email', dataIndex: 'email', width: 180 },
    latitude: { label: 'latitude', dataIndex: 'latitude', width: 100 },
    longitude: { label: 'longitude', dataIndex: 'longitude', width: 100 },
    status: { label: 'status', dataIndex: 'status', width: 100 },
    service_time: { label: 'serviceTime', dataIndex: 'serviceTime', width: 120 },
    time_slot_list: { label: 'timeSlotList', dataIndex: 'timeSlotList', width: 180 },
    location_image: { label: 'locationImage', dataIndex: 'locationImage', width: 120 },
    // P1 new fields
    grace_time: { label: 'graceTime', dataIndex: 'graceTime', width: 120 },
    dock_capacity: { label: 'dockCapacity', dataIndex: 'dockCapacity', width: 120 },
    dock_vehicle_mapping: { label: 'dockVehicleMapping', dataIndex: 'dockVehicleMapping', width: 200 },
    created_by: { label: 'createdBy', dataIndex: 'createdBy', width: 150 },
    updated_by: { label: 'updatedBy', dataIndex: 'updatedBy', width: 150 },
};

// Mapping from backend snake_case keys to frontend form field keys
export const backendToFormFieldMapping: Record<string, string> = {
    address_id: 'address_id',
    name: 'name',
    company_name: 'company_name',
    address_line_1: 'address_line_1',
    address_line_2: 'address_line_2',
    address_line_3: 'address_line_3',
    address_line_4: 'address_line_4',
    address_line_5: 'address_line_5',
    pincode: 'pincode',
    city: 'city',
    state: 'state',
    country: 'country',
    phone: 'phone',
    alternate_phone: 'alternate_phone',
    alternate_phone_2: 'alternate_phone_2',
    notes: 'notes',
    email: 'email',
    latitude: 'latitude',
    longitude: 'longitude',
    status: 'status',
    service_time: 'service_time',
    time_slot_list: 'time_slot_list',
    location_image: 'location_image',
    // P1 new fields
    grace_time: 'grace_time',
    dock_capacity: 'dock_capacity',
    dock_vehicle_mapping: 'dock_vehicle_mapping',
};
